import "./footer.css";
import { MdFavoriteBorder } from "react-icons/md";

const Footer = () => {
   return (
      <footer className="h6 font-medium mt-6">
         Made with by <MdFavoriteBorder color="white" /> amartyars
      </footer>
   );
};

export { Footer };
